import { PassengersProps, PeopleInfo } from './PeopleCounter';

export const RulesVB = {
  CHILDREN_BY_ADULT: 'childrenbyadult',
  MAX_CHILDREN_BY_ADULT: 'maxchildrenbyadult'
};

type ParsedRule = {
  rule: string;
  param: number;
};
const parseRule = (str: string) => {
  const params = str.split(':');
  const response: ParsedRule = { rule: '', param: -1 };
  if (params.length === 2) {
    response.rule = params[0]?.toLowerCase();
    response.param = Number(params[1]);
  } else {
    if (params[0]) {
      response.rule = params[0]?.toLowerCase();
      response.param = 1;
    }
  }
  return response;
};

const getPassengerOption = (
  passengers: Omit<PassengersProps, 'defaultSelection'>,
  name: string
) => {
  const index = passengers.options.findIndex((item) => item.name === name);
  return { index, ...passengers.options[index] };
};

export const evaluateRules = (
  rules: Array<string> = [],
  passengers: Omit<PassengersProps, 'defaultSelection'>
) => {
  const parsedRules = rules.map(parseRule);
  const adults = getPassengerOption(passengers, 'age1');
  const youths = getPassengerOption(passengers, 'age2');
  const children = getPassengerOption(passengers, 'age3');

  return (state: PeopleInfo, action: string, index: number) => {
    if (!Number.isInteger(index)) {
      console.error('**NOT_VALID_INDEX**');
      return { valid: true, ruleActions: () => {} };
    }
    let result = true;

    const evaluateRule = (parsedRule: ParsedRule) => {
      //rule infantsByAdult
      if (parsedRule.rule === RulesVB.CHILDREN_BY_ADULT) {
        if (action === 'ADD' && index === children.index) {
          result = result && state.count[index] + 1 <= parsedRule.param * state.count[adults.index];
        }
      }
      //rule maxChildren
      if (parsedRule.rule === RulesVB.MAX_CHILDREN_BY_ADULT) {
        if (action === 'ADD' && index === children.index) {
          result =
            result &&
            state.count[youths.index] + state.count[children.index] + 1 <=
              parsedRule?.param * state.count[adults.index];
        }
        if (action === 'ADD' && index === youths.index) {
          result =
            result &&
            state.count[youths.index] + state.count[children.index] + 1 <=
              parsedRule.param * state.count[adults.index];
        }
      }
    };

    parsedRules.forEach(evaluateRule);

    const ruleActions = (draft: any) => {
      parsedRules.forEach((parsedRule) => {
        const ruleParam = parsedRule.param;
        if (action === 'REMOVE' && index === adults.index) {
          if (parsedRule.rule === RulesVB.CHILDREN_BY_ADULT) {
            //remove the children count
            if (draft.count[children.index] > draft.count[adults.index] * ruleParam) {
              if (draft.count[children.index] - ruleParam >= 0) {
                let total = ruleParam;
                const rest = draft.count[children.index] % ruleParam;
                if (rest === 0) {
                  draft.count[children.index] -= ruleParam;
                } else {
                  draft.count[children.index] -= rest;
                  total = rest;
                }
                //remove the ages
                for (let i = 0; i < total; i++) {
                  draft.ages[children.index].pop();
                }
              }
            }
          }

          if (parsedRule.rule === RulesVB.MAX_CHILDREN_BY_ADULT) {
            const totalChildren = draft.count[youths.index] + draft.count[children.index];
            if (totalChildren > draft.count[adults.index] * ruleParam) {
              let total = draft.count[youths.index] + draft.count[children.index];
              let isYouth = true;
              while (total > draft.count[adults.index] * ruleParam) {
                isYouth = draft.count[youths.index] > draft.count[children.index];

                if (isYouth) {
                  if (draft.count[youths.index] > 0) {
                    draft.count[youths.index] -= 1;
                    draft.ages[youths.index].pop();
                  }
                } else {
                  if (draft.count[children.index] > 0) {
                    draft.count[children.index] -= 1;
                    draft.ages[children.index].pop();
                  }
                }
                total = draft.count[youths.index] + draft.count[children.index];
              }
            }
          }
        }
      });
    };

    return { valid: result, ruleActions };
  };
};
